import { FETCH_FILE_STATUS_REQUEST, FETCH_FILE_STATUS_SUCCESS, FETCH_FILE_STATUS_FAILURE, FETCH_FILE_STATUS_RESET } from "../../actions";
const initialStatusState = {
    loading: false,
    data: null,
    error: null,
};
const fileStatusReducer = (state = initialStatusState, action) => {
    switch (action.type) {
        case FETCH_FILE_STATUS_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, error: null });
        case FETCH_FILE_STATUS_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, data: action.payload, error: null });
        case FETCH_FILE_STATUS_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case FETCH_FILE_STATUS_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null });
        default:
            return state;
    }
};
export default fileStatusReducer;
